import { AttachmentToUpdate } from "./enquiry.model";

export class ItemLimitation {
    limitation?: string;
    isCustom?: boolean;
}

export class ItemToUpdate {
    itemNo?: string | null;
    customerItemNo?: string;
    alloySurcharge?: boolean;
    applicableNorms?: string | null;
    normGradesId?: number[];
    marketingGradeId?: number | null;
    rawMaterialGradeId?: number | null;
    gradeCustomerAnalysisLimitation?: ItemLimitation;
    gradeCustomerOtherLimitation?: ItemLimitation;
    unitSystem?: string;
    quantity?: number;
    quantityUom?: string | null;
    od?: number | null;
    odUom?: string | null;
    odToleranceMinus?: number;
    odTolerancePlus?: number;
    odToleranceUom?: string;
    wt?: number | null;
    wtUom?: string | null;
    id?: number | null;
    idUom?: string | null;
    idToleranceMinus?: number;
    idTolerancePlus?: number;
    idToleranceUom?: string;
    npsScheduleId?: number | null;
    typeOfTolerance?: string | null;
    lengthType?: string;
    lengthMin?: number;
    lengthMax?: number;
    lengthUom?: string;
    smsId?: number;
    marketFamilyId?: number;
    ut?: boolean | null;
    hydroTest?: boolean | null;
    endsCondition?: string;
    ht?: boolean | null;
    htAdditional?: boolean | null;
    inspectionType3dot2?: boolean | null;
    multipleCutting?: boolean | null;
    surfaceTypeId?: number;
    millId?: number;
    totalWeight?: number;
    totalWeightUom?: string;
    optionDate?: number;
    customerDeliveryDate?: number | null;
    attachments?: AttachmentToUpdate[] | null;
    wtToleranceMinus?: number;
    wtTolerancePlus?: number;
    wtToleranceUom?: string;
    tubeExecutionId?: number;
    energySurcharge?: boolean;
    uBent?: boolean;
    lengthNominal?: number | null;
    multipleLength?: boolean;
    testCondition?: string;
    sourceItemNo?: string | null;
    remarks?: string | null;
    isImportedFromAI?: boolean;
    cts?: boolean;
    dyePenetrant?: boolean;
    dyePenetrant100P?: boolean;
    penalty?: boolean;
    colorCoding?: boolean;
    specialOperations?: boolean;
    specialTests?: boolean;
    grindingHoning?: boolean;
    ec?: boolean;
    notStdPackaging?: boolean;
    materialCode?: string | null;
    sqlId?: number;
    offerSchemeCode?: string | null;
    remark?: string | null;
}
